import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "components/ui/dialog";
import { Button } from "components/ui/button";
import { Formik } from "formik";
import Text from "components/Text";
import { fontSizes } from "appconstants";
import InputField from "components/InputField";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { getUserDetail, updateUser } from "store/actions/user-action";

interface Props {
  open: boolean;
  onClose: () => void;
  fullName?: string;
  onDone?: () => void;
}

const UserModal = ({ open, onClose, fullName, onDone }: Props) => {
  const dispatch: AppDispatch = useDispatch();

  const { user } = useSelector((state: RootState) => state.common);
  const { user_loading } = useSelector((state: RootState) => state.user);

  const onSubmit = (values: any, resetForm: () => void) => {

    const api_data = {
      userId: user?.userId,
      fullName: values.fullName,
      email: user?.email,
      roleId: user?.roleId,
      updatedBy: user?.userId,
      isActive: true,
      notification: user?.notification

    };
    dispatch(
      updateUser(api_data, () => {
        resetForm();
        onClose();
        dispatch(getUserDetail(user))
      }),
    );
  };

  return (
    <Dialog open={open} onOpenChange={user_loading ? null : onClose}>
      <DialogContent className="max-w-[720px] rounded-xl">
        <DialogTitle className="hidden"></DialogTitle>
        <DialogDescription className="hidden"></DialogDescription>
        <Text text={"Change Name"} className="font-bold" size={fontSizes.h20} />

        <Formik
          initialValues={{ fullName: fullName ?? "" }}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={(values, functions) => {
            onSubmit(values, functions.resetForm);
          }}
        >
          {({
            values,
            errors,
            setFieldValue,
            setFieldError,
            handleSubmit,
            resetForm,
          }) => (
            <>
              <div className="grid grid-cols-1 gap-4">
                <div>
                  <InputField
                    label="Name"
                    placeholder="Enter Name"
                    value={values.fullName}
                    onChange={(text) => {
                      setFieldValue("fullName", text);
                      setFieldError("fullName", "");
                    }}
                  />
                </div>
              </div>

              <div className="mt-5 flex justify-between gap-4">
                <Button
                  variant="outline"
                  className="h-12 w-full rounded-xl border-primary text-primary"
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="h-12 w-full rounded-xl"
                  onClick={() => handleSubmit()}
                  loading={user_loading}
                >
                  {"Save"}
                </Button>
              </div>
            </>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default UserModal;
